'use strict';

var $alert = $('.pgn-wrapper .alert');
var showPeriod = 5000;

if ($alert.length) {
    $alert.each(function(i) {
        i++;
        setTimeout(function() {
            $(this).remove();
        }.bind(this), showPeriod * i);
    });
}
